import React from 'react';
import styled from 'styled-components';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <CompanyName>Sonor AI</CompanyName>

        <MainHeading>
          Let AI Handle the Calls
          <br />
          You Focus On Growth
        </MainHeading>

        <Subtitle>
          Revolutionize Lead Engagement
          <br />
          with AI Voice Agents
        </Subtitle>

        <BookCallButton href="https://cal.com/sonorai/intro" target="_blank" rel="noopener noreferrer">
          Book A Call
          <ArrowIcon>→</ArrowIcon>
        </BookCallButton>

        <FooterNav>
          <NavLink href="#why-us">Why Us</NavLink>
          <NavDivider></NavDivider>
          <NavLink href="#mission">Mission</NavLink>
          <NavDivider></NavDivider>
          <NavLink href="#faq">FAQ</NavLink>
          <NavDivider></NavDivider>
          <NavLink href="#imprint">Imprint</NavLink>
          <NavDivider></NavDivider>
          <NavLink href="#privacy">Privacy Policy</NavLink>
          {/* <NavDivider></NavDivider>
          <NavLink href="#works">Works</NavLink>
          <NavDivider></NavDivider>
          <NavLink href="#services">Services</NavLink>
          <NavDivider></NavDivider>
          <NavLink href="/contact">Contact</NavLink> */}
        </FooterNav>

        <Copyright>Copyright Sonor AI. All rights reserved.</Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  padding: 0 20px;
  background-image: radial-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 20px 20px;
  position: relative;
  overflow: hidden;
`;

const FooterContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 10px 0 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CompanyName = styled.div`
  color: var(--color-ui-orange);
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
`;

const MainHeading = styled.h2`
  font-size: 38px;
  font-weight: 700;
  color: white;
  line-height: 1.2;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: var(--color-text-gray);
  line-height: 1.6;
  margin-bottom: 40px;
`;

const BookCallButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background-color: #00A3FF;
  color: white;
  font-size: 16px;
  font-weight: 600;
  padding: 15px 30px;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 80px;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 168, 150, 0.3);
  }
`;

const ArrowIcon = styled.span`
  font-size: 20px;
  transition: transform 0.3s ease;

  ${BookCallButton}:hover & {
    transform: translateX(3px);
  }
`;

const FooterNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-bottom: 30px;
  flex-wrap: wrap;
`;

const NavLink = styled.a`
  color: var(--color-text-light);
  font-size: 16px;
  padding: 5px 10px;
  transition: color 0.3s ease;

  &:hover {
    color: var(--color-ui-orange);
  }
`;

const NavDivider = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--color-text-gray);
  opacity: 0.5;
`;

const Copyright = styled.p`
  font-size: 14px;
  color: var(--color-text-gray);
`;

export default Footer;
